module.exports = __webpack_public_path__ + "img/FTS_sword_sample.e077db80.png";